
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { GlobeIcon } from 'lucide-react';

interface RegionFilterProps {
  value: string | null;
  onChange: (value: string) => void;
}

export const STANDARD_REGIONS = [
  'Europe',
  'Asia',
  'North America',
  'South & Central America',
  'Africa',
  'Middle East',
  'Oceania',
  'Other'
] as const;

// Icon mapping for each region
const getRegionIcon = (region: string) => {
  return <GlobeIcon className="w-4 h-4 text-gray-500" />;
};

export const RegionFilter = ({ value, onChange }: RegionFilterProps) => {
  return (
    <div>
      <Label className="text-sm font-medium mb-2 block">Region</Label>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select region">
            {value && (
              <div className="flex items-center gap-2">
                {getRegionIcon(value)}
                <span>{value}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {STANDARD_REGIONS.map((region) => (
            <SelectItem key={region} value={region}>
              <div className="flex items-center gap-2">
                {getRegionIcon(region)}
                <span>{region}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
